import React, { useState } from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

type SavePresetModalProps = {
  isOpen: boolean;
  toggle: () => void;
  presetForm: any;
  setPresetForm: React.Dispatch<React.SetStateAction<any>>;
  savingPreset: boolean;
  onSave: () => void;
  title?: string;
  confirmLabel?: string;
};

const SaveFilterPresetModal = ({
  isOpen,
  toggle,
  presetForm,
  setPresetForm,
  savingPreset,
  onSave,
  title = "Save Filter",
  confirmLabel = "Save",
}: SavePresetModalProps) => {
  const [errors, setErrors] = useState<{ name?: string; description?: string }>(
    {}
  );

  const handleToggle = () => {
    setErrors({});
    toggle();
  };

  const handleSaveClick = () => {
    const nextErrors: { name?: string; description?: string } = {};

    if (!presetForm.name?.trim()) {
      nextErrors.name = "Name is required";
    }
    if (!presetForm.description?.trim()) {
      nextErrors.description = "Description is required";
    }

    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;

    onSave();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleToggle} centered>
      <ModalHeader toggle={handleToggle}>{title}</ModalHeader>

      <ModalBody>
        <div className="mb-3">
          <Label className="fw-semibold">Name</Label>
          <Input
            type="text"
            value={presetForm.name}
            placeholder="Filter name"
            onChange={(e) =>
              setPresetForm((prev: any) => ({
                ...prev,
                name: e.target.value,
              }))
            }
          />
          {errors.name && (
            <div className="text-danger small mt-1">{errors.name}</div>
          )}
        </div>

        {/* Description */}
        <div className="mb-3">
          <Label className="fw-semibold">Description</Label>
          <Input
            type="text"
            value={presetForm.description}
            placeholder="Short description"
            onChange={(e) =>
              setPresetForm((prev: any) => ({
                ...prev,
                description: e.target.value,
              }))
            }
          />
          {errors.description && (
            <div className="text-danger small mt-1">{errors.description}</div>
          )}
        </div>

        {/* Active */}
        <div className="mb-2 d-flex align-items-center" style={{ gap: 8 }}>
          <Input
            id="preset-active"
            style={{ marginTop: 0 }}

            type="checkbox"
            checked={presetForm.isActive}
            onChange={(e) =>
              setPresetForm((prev: any) => ({
                ...prev,
                isActive: e.target.checked,
              }))
            }
          />
          <Label for="preset-active" className="mb-0 fw-semibold">
            Active
          </Label>
        </div>

        {/* For All */}
        <div className="mb-2 d-flex align-items-center" style={{ gap: 8 }}>
          <Input
            id="preset-for-all"
            style={{ marginTop: 0 }}
            type="checkbox"
            checked={presetForm.isForAll}
            onChange={(e) =>
              setPresetForm((prev: any) => ({
                ...prev,
                isForAll: e.target.checked,
              }))
            }
          />
          <Label for="preset-for-all" className="mb-0 fw-semibold">
            For All
          </Label>
        </div>

        {/* Info box */}
        {presetForm.isForAll && (
          <div
            style={{
              fontSize: "12px",
              padding: "8px 10px",
              borderRadius: 6,
              backgroundColor: "#e7f1ff",
              color: "#0d6efd",
              lineHeight: 1.4,
            }}
          >
            This filter will be visible to <strong>all users</strong>.
            <br />
            Use this option carefully.
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" size="sm" onClick={handleToggle}>
          Cancel
        </Button>

        <Button
          color="primary"
          size="sm"
          disabled={savingPreset}
          onClick={handleSaveClick}
        >
          {savingPreset && (
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            />
          )}
          {confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SaveFilterPresetModal;
